<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { Author } from './Author'

const { t } = useI18n()

// eslint-disable-next-line @typescript-eslint/no-unused-vars
withDefaults(
  defineProps<{
    lastAuthor?: Author | null
  }>(),
  {
    lastAuthor: null
  }
)

</script>

<template>
  <div v-if="lastAuthor"
       class="flex items-baseline gap-1">
    <span class="font-ui text-ui-md text-foreground">{{ t('articleMeta.and') }} </span>
    <a class="font-button text-button-sm text-action-link-foreground pb-0.5 border-b-2 border-action-ghost-foreground"
       :target="lastAuthor.target ? lastAuthor.target : '_self'"
       :href="lastAuthor.url">
      {{ lastAuthor.titleLong || lastAuthor.titleShort }}
    </a>
  </div>
</template>
